import React from "react";
import { Hourglass } from "react-loader-spinner";

export default function Loader(props) {
  return (
    <Hourglass
      visible={props.visible}
      height="20"
      width="20"
      radius="48"
      ariaLabel="hourglass-loading"
      wrapperStyle={{}}
      wrapperClass=""
      colors={props.ibutton? ["#ffffff", "#173a8a"] : ["#306cce", "#173a8a"]}
    />
  );
}
